import {createApp} from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';

// ElementPlus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn';
// 加载
import '@/utils/title'
// 全局引入样式文件 tailwindcss
import '@/assets/output.css'
// 动画
import '@/assets/css/animation.css'
// 阿里图标
import '@/assets/icon/ali_iconfont.css'
// Y滚动条
import '@/assets/css/scrollbar.css'

/*
富文本
 */
import {config} from 'md-editor-v3'
import 'md-editor-v3/lib/style.css'
/*
全局组件
 */
// 后台-按钮边框
import rightToolbar from "@/components/rightToolbar/index.vue";
// 加载
import Loading from '@/components/loading/loading'

// 加载vuex状态数据
import {initVuex} from "@/utils/initVuex";

initVuex()

config({
    // markdownItPlugins(plugins) {
    //     return [
    //         ...plugins,
    //         {
    //             type: 'xss',
    //             plugin: XSSPlugin,
    //             options: {
    //                 extendedWhiteList: {
    //                     img: ['onerror'], // 保持原有的img标签配置
    //                 }
    //             },
    //         },
    //     ];
    // },
});


const app = createApp(App);

/*
全局组件
 */
//  rightToolbar 组件
app.component('rightToolbar', rightToolbar);


app.use(router)
    .use(store)
    .use(ElementPlus, { locale: zhCn })
    .use(Loading)
    .mount('#app')
